import { useState } from 'react';
import { useChat, ChatConversation } from '../../../contexts/ChatContext';
import AdminLayout from '../../../components/feature/AdminLayout';
import ConversationList from './components/ConversationList';
import ConversationView from './components/ConversationView';

export default function AdminMessagesPage() {
  const { allConversations, totalAdminUnread } = useChat();
  const [selected, setSelected] = useState<ChatConversation | null>(null);
  const [search, setSearch] = useState('');

  return (
    <AdminLayout>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-stone-900">Messages</h1>
        <p className="text-sm text-stone-500 mt-0.5">
          {totalAdminUnread > 0
            ? `${totalAdminUnread} unread message${totalAdminUnread > 1 ? 's' : ''}`
            : 'All caught up — no unread messages'}
        </p>
      </div>

      <div
        className="bg-white rounded-2xl border border-stone-200 overflow-hidden flex"
        style={{ height: 'calc(100vh - 220px)', minHeight: '480px' }}
      >
        {/* Conversation list */}
        <div className="w-72 border-r border-stone-100 shrink-0 flex flex-col">
          <div className="px-4 py-3 border-b border-stone-100">
            <p className="text-xs font-semibold text-stone-400 uppercase tracking-wider">
              Conversations ({allConversations.length})
            </p>
          </div>
          <ConversationList
            conversations={allConversations}
            selectedId={selected?.id ?? null}
            onSelect={(conv) => setSelected(conv)}
            search={search}
            onSearchChange={setSearch}
          />
        </div>

        {/* Conversation view */}
        <div className="flex-1 min-w-0">
          {selected ? (
            <ConversationView key={selected.id} conversation={selected} />
          ) : (
            <div className="h-full flex flex-col items-center justify-center gap-4 text-center px-8">
              <div className="w-16 h-16 bg-stone-100 rounded-full flex items-center justify-center">
                <i className="ri-chat-1-line text-stone-300 text-2xl" />
              </div>
              <div>
                <p className="text-sm font-semibold text-stone-500">Select a conversation</p>
                <p className="text-xs text-stone-400 mt-1">
                  Choose a conversation on the left to start replying
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
